import refreshLockToken from 'utils/core/refreshLockToken.util';
import refreshMainToken from 'utils/core/refreshMainToken.util';
import logger from 'utils/logger.util';

const L = logger('refreshTokens');

const refreshTokens = async ({ salonId, companyId, companyName, pin, force }) => {
  try {
    // must finish the main token first
    const main = await refreshMainToken({ salonId, companyId, companyName });

    // sending a request for the pin works only if the main token is there
    const lock = await refreshLockToken({ salonId, pin, force });

    return { main, lock };
  } catch (e) {
    throw L.warn('()', 'Failed to get token:', e);
  }
};

// noinspection JSUnusedGlobalSymbols
export default refreshTokens;
